import { Component, Input, EventEmitter, Output, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, Validator, AbstractControl, ValidationErrors, NG_VALIDATORS } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material';


@Component({
  selector: 'ap-confirm-terms',
  templateUrl: './confirm-terms.component.html',
  host: {
    'class': 'ap-confirm-terms',
  },
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: ConfirmTermsComponent,
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: ConfirmTermsComponent,
      multi: true
    }
  ]
})
export class ConfirmTermsComponent implements ControlValueAccessor, Validator {

  @Input() description: string;
  @Input() terms: string;
  @Input() value = false;

  @Output() changes = new EventEmitter<boolean>();

  isDisabled = false;

  constructor() { }

  // ## ControlValueAccessor ##

  _onTouched = () => { };
  _onChange = (value: any) => {};

  writeValue(value: boolean): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this._onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this._onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  // ###

  // ## Validator ##

  _validatorChange = () => {};

  validate(control: AbstractControl): ValidationErrors | null {
    return this.value != null ? null : { required: true };
  }

  registerOnValidatorChange?(fn: () => void): void {
    this._validatorChange = fn;
  }

  // ###

  onChange(args: MatCheckboxChange): void {
    this.writeValue(args.checked);
    this.changes.emit(args.checked);

    if (this._onChange != null) {
      this._onChange(args.checked);
    }

    if (this._onTouched != null) {
      this._onTouched();
    }
  }
}
